export const submitFormById = (formId: string) => (): void => {
  const formElement = document.getElementById(formId) as HTMLFormElement;
  formElement?.dispatchEvent(
    new Event('submit', { cancelable: true, bubbles: true })
  );
};
